import vue from 'vue';
import minimatch from 'minimatch';

import activationCodeWrapper from './activationCodeWrapper/activationCodeWrapper.js';
import activationCode from './activationCode/activationCode.js';
import instructionsButton from './button/button.js';
import instructionsLink from './link/link.js';
import instructionsImage from './image/image.js';
import instructionsText from './text/text.js';
import instructionsWrapper from './wrapper/wrapper.js';

const Vue = vue.default || vue;

const componentList = {
	activationCodeWrapper: Vue.component('activation-code-wrapper', activationCodeWrapper),
	activationCode: Vue.component('activation-code', activationCode),
	button: Vue.component('instructions-button', instructionsButton),
	image: Vue.component('instructions-image', instructionsImage),
	link: Vue.component('instructions-link', instructionsLink),
	text: Vue.component('instructions-text', instructionsText),
	wrapper: Vue.component('instructions-wrapper', instructionsWrapper)
};

/**
 * Return whitelisted attributes object with values
 * @param {object} node Each instruction item from Pricing
 * @param {string[]} [whitelist] Patterns of whitelisted attributes
 * @returns {object} Filtered element attributes
 */
const getComponentAttributes = (node, whitelist = ['src', 'href', 'alt', 'title', 'data-*', 'aria-*', 'os']) => {
	// If node.type is activationCode, pass prop content into component
	if (node.type === 'activationCode') {
		whitelist.push('content');
	}
	const filteredAttributesEntries = Object.entries(node).filter(([attribute]) => {
		return whitelist.some((pattern) => minimatch(attribute, pattern));
	});
	return {
		attrs: Object.fromEntries(filteredAttributesEntries)
	};
};

/**
 * Generate Vue components with childes for render function
 * @param {object} nodes
 * @param {Function} createElement
 * @returns {object}
 */
const generateComponents = (nodes, createElement) => {
	return (nodes || []).map((node) => {
		// Load component by type with it's attributes
		const elementType = componentList[node.type];
		const elementAttributes = getComponentAttributes(node);
		// Create component child items recursively
		const elementChildren = Array.isArray(node.content) ? node.content.map((childNodes) => {
			return generateComponents(Array.isArray(childNodes) ? childNodes : [childNodes], createElement);
		}) : [node.content];
		// Return functional component for render method
		return createElement(elementType, elementAttributes, elementChildren);
	});
};

export default {
	functional: true,
	name: 'CProductInstructions',
	render(createElement, { props }) {
		return generateComponents(props.product.thankYouPageText, createElement);
	},
	props: {
		product: {
			type: Object,
			default: {}
		}
	}
};
